export const traditional = [
  {
    number: 'TR100',
    hasModel: false,
  },
  {
    number: 'TR101',
    hasModel: false,
  },
  {
    number: 'TR102',
    hasModel: false,
  },
  {
    number: 'TR103',
    hasModel: false,
  },
  {
    number: 'TR104',
    hasModel: false,
  },
  {
    number: 'TR105',
    hasModel: false,
  },
  {
    number: 'TR106',
    hasModel: false,
  },
  {
    number: 'TR107',
    hasModel: false,
  },
  {
    number: 'TR108',
    hasModel: false,
  },
  {
    number: 'TR109',
    hasModel: false,
  },
  {
    number: 'TR110',
    hasModel: false,
  },
  {
    number: 'TR111',
    hasModel: false,
  },
  {
    number: 'TR112',
    hasModel: false,
  },
  {
    number: 'TR113',
    hasModel: false,
  },
  {
    number: 'TR114',
    hasModel: false,
  },
  {
    number: 'TR115',
    hasModel: false,
  },
  {
    number: 'TR116',
    hasModel: false,
  },
  {
    number: 'TR117',
    hasModel: false,
  },
  {
    number: 'TR118',
    hasModel: false,
  },
  {
    number: 'TR120',
    hasModel: false,
  },
  {
    number: 'TRX',
    hasModel: false,
  },
];
